module.exports = __webpack_public_path__ + "static/img/sydney-opera-house.01d2199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sydney/sydney-opera-house.jpg
// module id = 268
// module chunks = 1